module.exports = {
     development: "https://api.leyinfupay.cn:",  // 新正式
    production: "https://api.leyinfupay.cn:"
};



// WEBPACK FOOTER //
// ./src/common/conf/Server.js